import React from 'react';
import { FlexColumn, OutlinedButton, SvgIcon } from '@make-software/tg-mini-app-ui';

import { StyledTitle, TitleRow, useFantomRun } from '@/shared';
import GoldIcon from '@/shared/assets/icons/gold.svg';
import FantomRunIcon from '@/shared/assets/icons/ic-fantom-run.svg';

import { IconContainer, StyledBalanceRow, StyledEarnContainer } from './styled';

interface EarnSectionProps {
  onChallengesClick: () => void;
  onFantomRunClick: () => void;
}

export const EarnSection: React.FC<EarnSectionProps> = ({
                                                          onChallengesClick,
                                                          onFantomRunClick
                                                        }) => {
  const { plays } = useFantomRun(false);

  return (
    <>
      <TitleRow weight={1} size="lg" color="#FFFFFF" fontWeight={700} fontFamily="Inter">
        Earn
      </TitleRow>

      <StyledBalanceRow justify="stretch" gap="16px">
        <StyledEarnContainer>
          <IconContainer>
            <SvgIcon src={GoldIcon} size={24}></SvgIcon>
          </IconContainer>
          <FlexColumn gap={5}>
            <StyledTitle>Challenges</StyledTitle>
            <OutlinedButton
              title="Explore"
              onClick={onChallengesClick}
              width="100%"
              height={24}
              fontFamily="Inter"
              fontWeight={400}
              fontSize="12px"
            />
          </FlexColumn>
        </StyledEarnContainer>

        <StyledEarnContainer>
          <IconContainer>
            <SvgIcon src={FantomRunIcon} size={44}></SvgIcon>
          </IconContainer>
          <FlexColumn gap={5}>
            <StyledTitle>FANtom Run</StyledTitle>
            <OutlinedButton
              disabled={!plays}
              title={`Play (${plays}x)`}
              onClick={onFantomRunClick}
              width="100%"
              height={24}
              fontFamily="Inter"
              fontWeight={400}
              fontSize="12px"
            />
          </FlexColumn>
        </StyledEarnContainer>
      </StyledBalanceRow>
    </>
  );
};
